import {UNSET_USER_INFO,SET_USER_INFO} from '../types'

export const unSetUserInfo = () => ({ type: UNSET_USER_INFO });

export const setUserInfo = user => ({type : SET_USER_INFO , user})